
import { h, Fragment, render } from 'preact'
import { useEffect, useState, useRef } from 'preact/hooks'
import { createPortal } from 'preact/compat'
import { initialSessionFromDom, useSubmission } from './../hooks/useSubmission'

import { json } from './../utility/dom'
import { scrollTo } from './../utility/scrollTo'

import { SubmitButton } from './../components/SubmitButton'
import { ExpiryCounter } from './../components/ExpiryCounter'


export function init() {
	const reviewEl = document.getElementById('apply-review-form')
	const errorEl = document.getElementById('apply-review-errors')
	const session = initialSessionFromDom()
	const stages = json('#form-stages')
	reviewEl && render(
		createPortal(<ReviewForm session={session} stages={stages} errorEl={errorEl} />, reviewEl), 
		document.body
	)
}

function ReviewForm({ session, stages, errorEl }) {

	const beforeSubmit = data => ({ ...data, Stage: 'complete' })
	const onSuccess = () => window.location = stages.success
	const onError = () => {
		setTimeout(() => {
			const el = document.querySelector('[class*="error"]')
			el && scrollTo(el, -80)
		}, 20)
	}
	
	const { 
		expires, processing, submitted, validation,
		onSubmitComplete, extendSession,
	} = useSubmission({ session, beforeSubmit, onSuccess, onError })


	const errorTitle = validation?.invenias?.message || 'Could not process application'
	const errorMessage = {
		'getAssignmentById': 'The role you are applying for could not be found. The role may have been closed or deleted.',
		'uploadFile': 'There was a problem uploading your documents. Please try again or contact support if the problem persists.'
	}[validation?.invenias?.errorState?.name] || ''

	return <>
		<form onSubmit={onSubmitComplete}>
			{errorEl && createPortal(<>
				{validation?.invenias && <div class="message-box error">
					<>
						Sorry, there was a technical issue when processing your application.<br />
						Please email your CV and supporting statement to <a href="mailto:welcome@andersonquigley.com">welcome@andersonquigley.com</a> stating the role you are applying for – if your email address and telephone number aren’t included, please include them in your email.
					</>
    				{/* 
    				validation.invenias.message || 'Could not process application'}{errorMessage && ':'}<br />
    				<strong>{errorMessage}</strong>
    				*/}
    			</div>}
			</>, errorEl)}
			<SubmitButton class="button button--fill button--yellow" processing={processing || submitted}>
				{(processing || submitted) && 'Processing' || 'Complete'}
			</SubmitButton>
			<ExpiryCounter expires={expires} onExtend={extendSession} />
		</form>
	</>
}












